import { FC } from 'react';

import { useMediaQuery } from '@mui/material';

import BSTNAnimation from '@/components/Animations/BSTNAnimation';
import Meta from '@/components/Meta';

import Header from './Header';
import { useCurrentStep } from './hooks';
import CreateWorkspace from './steps/CreateWorkspace';
import ExistingWorkspace from './steps/ExistingWorkspace';
import ExistingWorkspaceSent from './steps/ExistingWorkspaceSent';
import Profile from './steps/Profile';
import { AnimationBackground, Container, Wrapper } from './styled';
import { OnboardingProps, OnboardingStep } from './types';

const mapStepToComponent: Record<OnboardingStep, FC> = {
  [OnboardingStep.Profile]: Profile,
  [OnboardingStep.CreateWorkspace]: CreateWorkspace,
  [OnboardingStep.JoinExisting]: ExistingWorkspace,
  [OnboardingStep.RequestedToJoin]: ExistingWorkspaceSent,
};

function Onboarding({ providedStep }: OnboardingProps) {
  const step = useCurrentStep();
  const isSmallScreen = useMediaQuery('(max-width:900px)');

  const stepsMap = mapStepToComponent;
  const Component = stepsMap[providedStep || step];

  return (
    <Meta responsive>
      <Container>
        {!isSmallScreen && (
          <AnimationBackground>
            <BSTNAnimation />
          </AnimationBackground>
        )}
        <Wrapper>
          <Header />
          <Component />
        </Wrapper>
      </Container>
    </Meta>
  );
}

export default Onboarding;
